import React from 'react';
import classNames from 'classnames';


import cdotLogo from '../../../static/cdot-2020-full.png';
import cdotLogoWhite from '../../../static/cdot-2020-full-white.png';
import cdotLogoShortWhite from '../../../static/cdot-2020-short-white.png';

import styles from './cdot.scss';
import PropTypes from 'prop-types';

const CdotLogo = ({
  className,
  short= false,
  light = false
}) => {
  if (short) {
    return (
      <img
        src={cdotLogoShortWhite}
        alt="CDOT"
        className={classNames(styles.cdot2020Short, className)}
      />
    );
  }
  return (
    <img
      src={light ? cdotLogoWhite : cdotLogo}
      alt="CDOT"
      className={classNames(styles.cdot2020, className)}
    />
  );
};

CdotLogo.propTypes = {
  className: PropTypes.string,
  light: PropTypes.bool,
  short: PropTypes.bool
};

export default CdotLogo;
